import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./Footer.css";
import hiveLogo from "../../assets/logos/hive_logo_normal.webp";

const Footer = ({ contentRef }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // Check if we're on a member page
    const isMemberPage =
      location.pathname.includes("/lupus") ||
      location.pathname.includes("/merilus") ||
      location.pathname.includes("/korrupt") ||
      location.pathname.includes("/mariommm") ||
      location.pathname.includes("/justlupus");

    if (isMemberPage) {
      // Navigate to home page first, then scroll after a brief delay
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        const websiteContent = document.querySelector(".websiteContent");
        if (section && websiteContent) {
          websiteContent.scrollTo({
            top: section.offsetTop,
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      // Already on main page, just scroll
      const section = document.getElementById(sectionId);
      if (section && contentRef && contentRef.current) {
        const sectionTop = section.offsetTop;
        contentRef.current.scrollTo({
          top: sectionTop,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <footer className="footer">
      <div className="footer_container">
        <div className="footer_content">
          <div className="footer_left">
            <img src={hiveLogo} alt="Hive Team Logo" className="footer_logo" />
            <div className="footer_company">
              <p className="company_name">Lupus Development SRL</p>
              <p className="company_cui">CUI: 50595916</p>
            </div>
          </div>

          <div className="footer_links">
            <button type="button" onClick={() => scrollToSection("homePageS")}>
              Home
            </button>
            <button type="button" onClick={() => scrollToSection("about")}>
              About
            </button>
            <button type="button" onClick={() => scrollToSection("ourteam")}>
              Team
            </button>
            <button type="button" onClick={() => scrollToSection("hivePort")}>
              Portfolio
            </button>
            <button type="button" onClick={() => scrollToSection("service")}>
              Services
            </button>
            <button type="button" onClick={() => scrollToSection("contact")}>
              Contact
            </button>
          </div>

          <div className="footer_legal">
            <Link to="/terms">Terms</Link>
            <span>•</span>
            <Link to="/privacy">Privacy</Link>
            <span>•</span>
            <Link to="/hiveteam-pradais-samuel">Founder</Link>
            <span>•</span>
            <p>&copy; {new Date().getFullYear()} Hive Team</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
